<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
            <v-layout row wrap class="debt-summary-row">
              <v-flex lg4 md4 sm12 xs12 v-for="card in summaryCards" :key="card.title" class="pa-2">
                <v-card class="debt-summary-card" :class="card.className">
                  <v-card-text>
                    <div class="debt-summary-label">{{ card.title }}</div>
                    <div class="debt-summary-value">{{ card.value | currency }}</div>
                    <div class="debt-summary-note">{{ card.note }}</div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table fixed-header height="calc(100vh - 300px)"   :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
              <template v-slot:header="{ props }"><table-header-filter :headers="props.headers" :viewName="viewName" v-on:applyFilter="applyFilter"></table-header-filter></template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.UID }}</td>
                  <td>{{ item.Username }}</td>
                  <td>{{ item.ReportDate | display_date('DD-MM-YYYY') }}</td>
                  <td class="text-end">{{ item.TotalGoods | currency }}</td>
                  <td class="text-end">{{ item.TotalRecharge | currency }}</td>
                  <td class="text-end">{{ item.Debt | currency }}</td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr class="total-summary-td">
                  <td colspan="3" class="text-center font-weight-bold">Tổng cộng</td>
                  <td class="text-end font-weight-bold">{{ summary.TotalGoods | currency }}</td>
                  <td class="text-end font-weight-bold">{{ summary.TotalRecharge | currency }}</td>
                  <td class="text-end font-weight-bold">{{ summary.TotalDebt | currency }}</td>
                </tr>
              </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      valid: true,
      headers: [
        {
          text: "UID",
          value: "UID",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Username",
          value: "Username",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Ngày",
          value: "ReportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: "Tổng tiền hàng",
          value: "TotalGoods",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Tổng nạp",
          value: "TotalRecharge",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Công nợ",
          value: "Debt",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      pagination: {
          ...configs.PAGINATION,
          sortBy: ["ReportDate"]
      },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      viewName: "bao-cao-cong-no"
    };
  },
  watch: {
    pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.filter_data();
        },
        deep: true
    },
  },
  computed: {
    ...mapState({
      items: state => state.report.debtReport.data,
      total_rows: state => state.report.debtReport.total,
      summary: state => state.report.debtReport.summary,
      loading: state => state.report.loading,
    }),
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    summaryCards() {
      const summary = this.summary || {};
      return [
        {
          title: "Công nợ phải thu",
          value: summary.InDebt || 0,
          note: "Tiền hàng lớn hơn tổng nạp",
          className: "summary-card-positive"
        },
        {
          title: "Công nợ phải trả",
          value: summary.OutDebt || 0,
          note: "Tổng nạp lớn hơn tiền hàng",
          className: "summary-card-neutral"
        },
        {
          title: "Tổng công nợ",
          value: summary.TotalDebt || 0,
          note: "Tiền phiếu xuất trừ tiền nạp",
          className: "summary-card-primary"
        }
      ];
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("report/getDebtReport", param);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    exportExcel() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("report/exportDebtReport", param);
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_EXPORT_EXCEL", this.exportExcel);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_EXPORT_EXCEL", this.exportExcel);
  }
};
</script>
<style scoped>
.debt-summary-row {
  margin: -8px;
}

.debt-summary-card {
  border-radius: 16px;
  color: #1e293b !important;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.summary-card-positive {
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);
  border: 1px solid #ffedd5;
}

.summary-card-neutral {
  background: linear-gradient(135deg, #f0fdfa 0%, #99f6e4 100%);
  border: 1px solid #ccfbf1;
}

.summary-card-primary {
  background: linear-gradient(135deg, #eff6ff 0%, #bfdbfe 100%);
  border: 1px solid #dbeafe;
}

.debt-summary-label {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  opacity: 0.92;
}

.debt-summary-value {
  margin-top: 10px;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.2;
}

.debt-summary-note {
  margin-top: 8px;
  font-size: 13px;
  opacity: 0.88;
}
</style>
